import { stringToCapitalizeCase } from "../../_shared/stringToCapitalizeCase";
import UserInput from "../1_Inputs/UserInput";

export default class UserEntity {
  private readonly _id: string;
  private readonly _code: string | null;
  private readonly _firstName: string;
  private readonly _lastName: string | null;
  private readonly _document: {
    type: string;
    number: string;
  };
  private readonly _role: "CANDIDATE" | "STUDENT" | "STUDENTCLASS";
  private readonly _properties: any;

  constructor(params: UserInput) {
    this._id = params.id;
    this._code = params.code;
    this._firstName = params.firstName;
    this._lastName = params.lastName;
    this._document = params.document;
    this._role = params.role;
    this._properties = params.properties;
  }

  private getCapitalizeName(): string {
    const values = this._firstName?.split(" ");

    return values.map((v) => stringToCapitalizeCase(v)).join(" ");
  }

  public toJSON() {
    return {
      id: this._id,
      code: this._code,
      firstName: this.getCapitalizeName(),
      lastName: this._lastName,
      document: this._document,
      role: this._role,
      properties: this._properties,
    };
  }
}
